import { SpecManager } from "../specs/SpecManager";
import Spec from "../specs/Spec";
import axios from "axios";
import { BundleBase } from "../bundle/BundleBase";
import { DeclarationBase } from "../declaration/DeclarationBase";
import { sanitize, sanitizeInlineStyle } from "../../helpers/sanitizer";

type FormType = {
    rules: any;
    form: any;
    cerfa: any;
    values: any;
    image: string;
    id: string;
    year?: string;
};

export class SheetManager extends SpecManager {
    constructor(
        public id: string,
        public _form: FormType,
        public radicals: { [k: string]: number } = {},
        public bundleBase: BundleBase,
        public declarationBase: DeclarationBase,
        readonly: boolean = false,
        stream: {
            [k: string]: { userValue: string | number | boolean; computedValue: number };
        } = null,
        private repeatNumber: number = 1
    ) {
        const rules = _form?.rules || _form.form?.rules || {};
        super(rules, readonly, stream);
        this.listFields = this.retrieveKeysFromForm();

        this.initializeFields();
        if (this.bundleBase) {
            this.fillSpecs(this.bundleBase.specs);
        }
        if (this.declarationBase) {
            this.fillSpecs(this.declarationBase.specs);
        }
        return this;
    }

    get filterDependencyKeys(): string {
        // return ""
        if (this.bundleBase?.bundleN1) {
            return "";
        }
        return "N1:";
    }

    get name() {
        if (this.repeatNumber > 1) {
            return `${this.cerfaNumber}_${this.repeatNumber}`;
        }
        return this.cerfaNumber;
    }

    get form() {
        return this._form?.form;
    }

    get millesim() {
        return this._form?.year;
    }

    get cerfa() {
        return this._form?.cerfa;
    }

    get values() {
        if (this._form?.values) {
            return this._form?.values;
        }
        // if (this._form?.form.values) {
        //     return this._form?.form.values
        // }
        debugger;
        return {};
    }

    get imageUrl() {
        return this._form?.image;
    }

    get formId() {
        return this._form?.id;
    }

    get cerfaNumber() {
        return this.form?.name;
    }

    get title() {
        return this.form?.title;
    }

    get tables() {
        if (this.form?.tables) {
            return this.form.tables;
        }
        // if (this.form?.form?.tables) {
        //     return this.form.form.tables
        // }
        debugger;
        return [];
    }

    retrieveKeysFromForm() {
        let listKeys = SheetManager.retrieveKeysFromTable(this.tables);
        // add mising values from values
        if (this.values) {
            for (const key in this.values) {
                if (listKeys.indexOf(key) === -1) {
                    listKeys.push(key);
                }
            }
        }
        return listKeys;
    }

    static retrieveKeysFromTable(tables) {
        let listKeys = [];
        if (tables?.length) {
            tables.forEach((table) =>
                table.rows.forEach((row) => {
                    if (row.repeat) {
                        for (let i = 0; i < row.repeatMaxCount; i++) {
                            row.columns.forEach((col) => {
                                if (col.key) {
                                    listKeys.push(`${SheetManager.getRepeatedKey(col.key, i + 1)}`);
                                }
                                if (col.tables) {
                                    listKeys = listKeys.concat(
                                        SheetManager.retrieveKeysFromTable(col.tables)
                                    );
                                }
                            });
                        }
                    } else {
                        row.columns.forEach((col) => {
                            if (col.component) {
                                listKeys.push(
                                    ...SheetManager.getComponentKeys(col.key, col.component)
                                );
                            } else if (col.key) {
                                listKeys.push(col.key);
                            }
                            if (col.tables) {
                                listKeys = listKeys.concat(
                                    SheetManager.retrieveKeysFromTable(col.tables)
                                );
                            }
                        });
                    }
                })
            );
        }
        return listKeys;
    }

    static getRepeatedKey(key, index) {
        if (index === 1) {
            return key;
        }
        return `${key}_${index.toString().padStart(2, "0")}`;
    }

    getKeyValue(key) {
        // console.log("print cerfa - key: ", key)
        return this.fields[key]?.displayValue;
    }

    static getComponentKeys(key: string, component: string) {
        if (component.startsWith("address")) {
            const addressTable = require(`../taxform/addressTypes/${component}.json`);
            return [
                ...this.retrieveKeysFromTable(addressTable.tables).map((k) => `${key}${k}`),
                key,
            ];
        } else if (component.startsWith("financial")) {
            const financialTable = require(`../taxform/financial/${component}.json`);
            return [
                ...this.retrieveKeysFromTable(financialTable.tables).map((k) => `${key}${k}`),
                key,
            ];
        } else {
            console.error("unknown component: ", component);
            debugger;
        }
    }

    async getStaticHtml(mode: "html" | "png" = "html"): Promise<string> {
        if (mode === "html") {
            return this.printHtml();
        }
        return await this.printCerfa();
    }

    async printCerfa(): Promise<string> {
        let html = "";
        let style = "";

        if (this.imageUrl) {
            style = await styleSvg(this.imageUrl);
            if (!style) {
                style = "";
                html += `<div style='width: 100%;color:red;'>Impossible de charger l'image pour le cerfa ${sanitize(
                    this.name
                )}</div>`;
            }
        } else {
            html += `<div style='width: 100%;color:red;'>Image non définie pour le cerfa ${sanitize(
                this.name
            )}</div>`;
        }

        html += `<div style='width: 100%;'>`;
        html += `<svg viewBox="0 0 1240 1754" style="${style}">`;

        for (const value of this.cerfa.values) {
            html += `<foreignObject
                        x="${value?.["boundingBox"]?.left}"
                        y="${value?.["boundingBox"]?.top}"
                        width="${value?.["boundingBox"]?.width}"
                        height="${value?.["boundingBox"]?.height}"
                        style="text-align: ${
                            this.justifyInputRight(value["key"]) ? "end" : "start"
                        };"
                    >${this.getKeyValue(value["key"]) || ""}</foreignObject>`;
        }

        html += `</svg>`;
        html += `</div>`;

        return html;
    }

    justifyInputRight(key_) {
        if (key_.includes("_@")) {
            return false;
        }
        const [key] = key_.split("_");
        const value = this.values[key];
        if (this.cerfaNumber.startsWith("2072SA2")) {
            return true;
        }
        if (value?.type && ["number", "quantity"].includes(value.type)) {
            return true;
        }
        return false;
        // return true
    }

    printHtml(form = this.form): string {
        if (!form || !form.tables) return "";

        let html = "";

        for (const t of form.tables) {
            if (!t.rows) continue;

            let isTab = false;

            for (let i = 0; i != t.rows.length; i += 1) {
                if (t.rows.at(i).columns.length > 1) {
                    isTab = true;
                }
            }

            for (const row of t.rows) {
                if (row.repeat) {
                    for (let i = 1; i < row.repeatMaxCount; i++) {
                        html += `<div style='display: flex; width: 100%; font-size: 12px;'>`;
                        for (const col of row.columns) {
                            html += `<div style='${styleFormDiv(
                                col,
                                this.values[col?.key || ""],
                                isTab
                            )}'>`;

                            if (col.hasOwnProperty("type")) {
                                if (
                                    col["type"] === "title" &&
                                    col["value"] !== "" &&
                                    col["style"]
                                ) {
                                    html += col["value"];
                                }
                            } else if (col.hasOwnProperty("tables")) {
                                html += this.printHtml(col["tables"]);
                            } else {
                                html +=
                                    this.getKeyValue(
                                        SheetManager.getRepeatedKey(col?.["key"], i)
                                    ) || "";
                            }
                            html += `</div>`;
                        }
                        html += `</div>`;
                    }
                } else {
                    html += `<div style='display: flex; width: 100%; font-size: 12px;'>`;
                    for (const col of row.columns) {
                        html += `<div style='${styleFormDiv(
                            col,
                            this.values[col?.key || ""],
                            isTab
                        )}'>`;
                        if (col.hasOwnProperty("type")) {
                            if (col["type"] === "title" && col["value"] !== "" && col["style"]) {
                                html += col["value"];
                            }
                        } else if (col.hasOwnProperty("tables")) {
                            html += this.printHtml(col["tables"]);
                        } else {
                            html += this.getKeyValue(col?.["key"]) || "";
                        }
                        html += `</div>`;
                    }
                    html += `</div>`;
                }
            }
        }

        return html;
    }

    // getFields(): { [k: string]: Spec } {
    //     let fields = {};
    //     Object.entries(this.fields).map(([key, value]) => {
    //         fields[value.uniqueKey] = value;
    //     });
    //     return fields;
    // }

    setRadicals(radicals: { [k: string]: number }) {
        this.radicals = radicals;
        this.update();
    }

    getRadicalComposition(radNumber: string) {
        const accounts = [];
        if (this.bundleBase) {
            const radNumberRegEx = /\[RAD([0-9]+)\]/g;
            let m;
            while ((m = radNumberRegEx.exec(radNumber)) !== null) {
                const radN = m[1];
                accounts.push(...this.bundleBase.getRadicalComposition(radN));
            }
        } else {
            debugger;
        }

        // let rad = radNumber.replace("[RAD", "").replace("]", "");
        return accounts;
    }

    getRadicalList(func) {
        if (this.bundleBase) {
            const radicals = [];
            const radNumberRegEx = /\[RAD([0-9]+)\]/g;
            let m;
            while ((m = radNumberRegEx.exec(func)) !== null) {
                const radN = m[1];
                radicals.push(radN);
            }
            return this.bundleBase.getRadicalList(radicals);
        }
        return [];
    }

    async createAdditionalPage(complementCerfaNumber: string) {
        if (this.bundleBase?.allForms?.length) {
            const complementForm = this.bundleBase.allForms.find(
                (f) => f.cerfa === complementCerfaNumber
            );
            if (complementForm) {
                await this.bundleBase.createAdditionalPage(complementCerfaNumber);
            } else {
                console.error("complementary cerfa: ", complementCerfaNumber, "not found");
                debugger;
            }
        } else if (this.declarationBase?.allForms?.length) {
            const complementForm = this.declarationBase.allForms.find(
                (f) => f.cerfa === complementCerfaNumber
            );
            if (complementForm) {
                await this.declarationBase.createAdditionalPage(complementCerfaNumber);
            } else {
                console.error("complementary cerfa: ", complementCerfaNumber, "not found");
                debugger;
            }
        } else {
            console.error("forms not found");
            debugger;
        }
    }

    afterUpdate() {
        const cerfas = ["2033E", "2035E", "2059E", "2072E"];
        if (cerfas.indexOf(this.cerfaNumber) !== -1) {
            const field = this.fields["KD"];
            if (field) {
                const value = Spec.getValue(field);
                const kaField = this.fields["KA"];
                if (kaField) {
                    if (value < 152500) {
                        // console.log(field.constructor?.name)
                        if (kaField.constructor?.name === "SpecValue") {
                            kaField.readonly = false;
                            kaField.value = "";
                        }
                        kaField.readonly = true;
                        // field.s
                    } else {
                        kaField.readonly = false;
                    }
                } else {
                    debugger;
                    console.error("KA not found");
                }
            } else {
                debugger;
                console.error("KD not found");
            }
        }
        const field = this.fields["NEANT"];
        if (field) {
            const value = this.isEDIEmpty ? "X" : "";
            if (field.value !== value) {
                field.value = value;
            }
        }
    }

    setSheetN1(sheetN1: SheetManager) {
        if (!sheetN1) {
            debugger;
            return;
        }

        for (const key in sheetN1.fields) {
            // const n1Key = key.replace(this.cerfaNumber, 'N1')
            this.fields[`N1:${key}`] = sheetN1.fields[key];
        }
    }

    isEDIEmptyValue(key, value) {
        let finalValue = value;
        if (typeof finalValue === "number") {
            finalValue = Math.round(finalValue);
        }
        if (finalValue || this._form.values[key.substring(0, 2)]?.EDIMandatory) {
            const type = this._form.values[key.substring(0, 2)]?.type;
            if (type && type !== "fixed") {
                return false;
            }
        }
        return true;
    }

    get isEDIEmpty() {
        if (this.specs?.length) {
            // Front
            for (const spec of this.specs) {
                if (!this.isEDIEmptyValue(spec.key, spec.value)) {
                    return false;
                }
            }
        } else {
            // back
            for (const [key, value] of Object.entries<{
                userValue?: number | string | boolean;
                computedValue?: number;
                aIsUserValue?: boolean;
                conditionValue?: boolean;
                aValue_?: number | string | boolean;
                bValue_?: number | string | boolean;
            }>(this.stream)) {
                let finalValue = Spec.getValue(value);
                if (!this.isEDIEmptyValue(key, finalValue)) {
                    return false;
                }
            }
        }

        return true;
    }
}

function styleFormDiv(col, value = null, isTab = true) {
    let style = null;
    if (isTab) {
        style = {
            width: col.width + "%",
            ...col.style,
            display: value && value.type === "formattedText" ? "block" : "flex",
            float: "left",
            "font-size": "12px",
            "box-shadow": `2px 0 0 0 #888,
                0 2px 0 0 #888,
                2px 2px 0 0 #888,   /* Just to fix the corner */
                2px 0 0 0 #888 inset,
                0 2px 0 0 #888 inset`,
            padding: col?.component?.includes("address") || col.tables ? "none" : "0px 5px",
            "min-height": "18px",
            "justify-content": col?.style?.["text-align"] || "start",
            "align-items": "center",
            "box-sizing": "border-box",
            "-webkit-print-color-adjust": "exact !important" /* Chrome, Safari 6 – 15.3, Edge */,
            "color-adjust": "exact !important" /* Firefox 48 – 96 */,
            "print-color-adjust": "exact !important",
        };
    } else {
        style = {
            width: col.width + "%",
            ...col.style,
            display: value && value.type === "formattedText" ? "block" : "flex",
            float: "left",
            "font-size": "12px",
            padding: col?.component?.includes("address") || col.tables ? "none" : "0px 5px",
            "min-height": "18px",
            "justify-content": col?.style?.["text-align"] || "start",
            "align-items": "center",
            "-webkit-print-color-adjust": "exact !important" /* Chrome, Safari 6 – 15.3, Edge */,
            "color-adjust": "exact !important" /* Firefox 48 – 96 */,
            "print-color-adjust": "exact !important",
        };
    }

    return Object.entries(style)
        .map(([key, value]) => `${key}: ${value};`)
        .join("");

    // return styleString
}

async function styleSvg(imageUrl) {
    if (!imageUrl) {
        debugger;
        return "";
    }
    let response = null;
    try {
        response = await axios({
            method: "GET",
            url: imageUrl,
            responseType: "arraybuffer",
            headers: {
                "Cache-Control": "no-cache",
            },
        });
    } catch (e) {
        debugger;
        console.error("Error loading image", e);
        return "";
    }

    let u8 = new Uint8Array(response.data);
    // @ts-ignore
    let b64encoded = btoa(
        ([] as any).reduce.call(
            u8,
            function (p, c) {
                return p + String.fromCharCode(c);
            },
            ""
        )
    );
    let mimetype = "image/png";
    const img = "data:" + mimetype + ";base64," + b64encoded;

    const style = {
        width: "-webkit-fill-available",
        height: "auto",
        "background-size": "contain",
        "background-image": `url(${img})`,
    };

    return Object.entries(style)
        .map(([key, value]) => `${key}: ${value};`)
        .join("");
}
